import { Controller } from "@hotwired/stimulus"

// Single-open accordion. Each item: a button (data-action="accordion#toggle", data-index,
// aria-controls) + a panel target. The "+" / "−" indicator is the button's aria-hidden span.
export default class extends Controller {
  static targets = ["panel"]

  toggle(event) {
    const idx = Number(event.currentTarget.dataset.index)
    this.panelTargets.forEach((panel, i) => {
      const open = i === idx && panel.classList.contains("hidden")
      panel.classList.toggle("hidden", !open)
      const btn = this.element.querySelector(`[aria-controls="${panel.id}"]`)
      if (!btn) return
      btn.setAttribute("aria-expanded", String(open))
      const icon = btn.querySelector("[aria-hidden='true']")
      if (icon) icon.textContent = open ? "−" : "+"
    })
  }
}
